<template>
  <div class="create-union">
    <Header />
    <Main>
      <h3 class="text-center">Создание профсоюза</h3>
      <b-overlay :show="loading">
        <union-form v-model="unionData" class="create-union__form" />
      </b-overlay>
    </Main>
    <bottom-overlay v-if="edited">
      <b-button
        @click="createUnion"
        block
        squared
        variant="success"
        class="create-person__create-button"
        :disabled="loading"
      >
        Создать спортзал
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import BottomOverlay from "@/components/BottomOverlay";
import UnionModel from "@/components/Forms/Union/models/unionModel";
import UnionForm from "@/components/Forms/Union/UnionForm";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: { UnionForm, BottomOverlay, Main, Header },
  mixins: [pageTitleMixin],
  data() {
    return {
      unionData: new UnionModel(),
      loading: false
    };
  },
  methods: {
    createUnion() {
      this.loading = true;
      this.$store
        .dispatch("unions/createUnion", this.unionData)
        .then(() => this.$router.push(`/unions`))
        .catch(() => (this.loading = false));
    }
  },
  computed: {
    edited: ({ unionData }) =>
      JSON.stringify(unionData) !== JSON.stringify(new UnionModel())
  }
};
</script>

<style lang="scss">
.create-union {
  &__form {
    margin: 0 5px;
  }
}
</style>
